module.exports = __webpack_public_path__ + "static/cmo_logo-4dd9fa32cc6281f94c6a99994b9fcf40.jpg";